import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { BorderRadius, Colors, FontSizes, FontWeights } from '../Theme';

const ButtonMenu = ({ buttons }) => {
  const [hover, setHover] = useState(null);
  const styles = {
    component: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexFlow: 'wrap',
      paddingBottom: 40
    },
    box_button: {
      width: 120,
      height: 120,
      margin: '0 10px 20px',
      padding: 20,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      textAlign: 'center',
      border: '1px solid #ccc',
      borderRadius: BorderRadius.DEFAULT,
      cursor: 'pointer',
      position: 'relative'
    },
    box_button_hover: {
      border: `2px solid ${Colors.PRIMARY.hex}`
    },
    box_button_icon: {
      fontSize: 40
    },
    box_button_label: {
      marginTop: 10,
      fontSize: FontSizes.MEDIUM,
      fontWeight: FontWeights.MEDIUM
    },
    box_button_disabled: {
      opacity: 0.5,
      cursor: 'default'
    },
    disabled_msg: {
      fontSize: FontSizes.SMALL,
      fontWeight: FontWeights.MEDIUM,
      position: 'absolute',
      top: 10,
      left: -1,
      right: -1,
      padding: 4,
      background: Colors.PRIMARY.hex,
      color: '#fff',
      zIndex: 2
    }
  };

  return (
    <div style={styles.component}>
      {buttons.map(button => {
        const { onClick, id, disabled_msg, label, icon } = button;
        const is_hovering = button.id === hover && button.onClick;
        const is_disabled = !button.onClick;

        return (
          <div
            key={id}
            onClick={onClick}
            onMouseEnter={setHover.bind(null, id)}
            onMouseLeave={setHover.bind(null, null)}
            style={Object.assign({}, styles.box_button, is_hovering && styles.box_button_hover)}
          >
            {is_disabled && disabled_msg ? (
              <div style={styles.disabled_msg}>{disabled_msg}</div>
            ) : null}
            <i
              className={`mdi ${icon}`}
              style={Object.assign(
                {},
                styles.box_button_icon,
                is_disabled && styles.box_button_disabled
              )}
            />
            <div
              style={Object.assign(
                {},
                styles.box_button_label,
                is_disabled && styles.box_button_disabled
              )}
            >
              {label}
            </div>
          </div>
        );
      })}
    </div>
  );
};

ButtonMenu.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      onClick: PropTypes.func,
      label: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired
    })
  ).isRequired
};

export default ButtonMenu;
